export const GET_BUNDLES: string = 'src/pages/bundles/GET_BUNDLES';
export const GET_BUNDLES_SUCCESS: string =
  'src/pages/bundles/GET_BUNDLES_SUCCESS';
export const GET_BUNDLES_FAILED: string =
  'src/pages/bundles/GET_BUNDLES_FAILED';

export const GET_BUNDLE_WITH_ID: string =
  'src/pages/bundles/GET_BUNDLE_WITH_ID';
export const GET_BUNDLE_WITH_ID_SUCCESS: string =
  'src/pages/bundles/GET_BUNDLE_WITH_ID_SUCCESS';
export const GET_BUNDLE_WITH_ID_FAILED: string =
  'src/pages/bundles/GET_BUNDLE_WITH_ID_FAILED';

export const UPDATE_BUNDLE_STATUS: string =
  'src/pages/bundles/UPDATE_BUNDLE_STATUS';
export const UPDATE_BUNDLE_STATUS_SUCCESS: string =
  'src/pages/bundles/UPDATE_BUNDLE_STATUS_SUCCESS';
export const UPDATE_BUNDLE_STATUS_FAILED: string =
  'src/pages/bundles/UPDATE_BUNDLE_STATUS_FAILED';
export const UPDATE_BUNDLE: string =
  'src/pages/bundles/UPDATE_BUNDLE';
export const UPDATE_BUNDLE_SUCCESS: string =
  'src/pages/bundles/UPDATE_BUNDLE_SUCCESS';
export const UPDATE_BUNDLE_FAILED: string =
  'src/pages/bundles/UPDATE_BUNDLE_FAILED';

export const CANCEL_BUNDLE: string = 'src/pages/bundles/CANCEL_BUNDLE';
export const CANCEL_BUNDLE_SUCCESS: string =
  'src/pages/bundles/CANCEL_BUNDLE_SUCCESS';
export const CANCEL_BUNDLE_FAILED: string =
  'src/pages/bundles/CANCEL_BUNDLE_FAILED';

export const GET_LOGS: string = 'src/pages/bundles/GET_LOGS';
export const GET_LOGS_SUCCESS: string = 'src/pages/bundles/GET_LOGS_SUCCESS';
export const GET_LOGS_FAILED: string = 'src/pages/bundles/GET_LOGS_FAILED';

export const GET_ALL_BUNDLES: string = 'src/pages/bundles/GET_ALL_BUNDLES';
export const GET_ALL_BUNDLES_SUCCESS: string = 'src/pages/bundles/GET_ALL_BUNDLES_SUCCESS';
export const GET_ALL_BUNDLES_FAILED: string = 'src/pages/bundles/GET_ALL_BUNDLES_FAILED';

export const CLEAR_BUNDLE: string = 'src/pages/bundles/CLEAR_BUNDLE'
